export default {
	person: "Personne",
	journeyStage: "Étape du parcours",
	since: "Depuis",
	createAssignment: "Affecter un rôle",
	assignNewPosition: "Affecter une nouvelle étape du parcours",
	confirmDeleteMessage: "Êtes-vous sûr de vouloir supprimer cette affectation ? Cette action est irréversible.",
	journeyProgressionInfo: "Seules les étapes du parcours au-dessus du niveau actuel ({currentLevel}) peuvent être sélectionnées.",
	createSuccess: "Affectation créée avec succès !",
	deleteSuccess: "Affectation supprimée avec succès !",
	createError: "Erreur lors de la création de l'affectation",
	deleteError: "Erreur lors de la suppression de l'affectation",
};
